export default "__VITE_ASSET__2n8PzahW__"